// extracted by mini-css-extract-plugin
export default {"header":"UsersAdminView_header__txoOn","button":"UsersAdminView_button__vSywm"};